export const SOCIAL_META = [
  { key: "scholar", label: "Google Scholar" },
  { key: "orcid", label: "ORCID" },
  { key: "researchmap", label: "researchmap" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "x", label: "X" },
];

export function SocialIcon({ kind }) {
  switch (kind) {
    case "linkedin":
      return (
        <svg
          viewBox="0 0 24 24"
          width="30"
          height="30"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      );
    case "scholar":
      return (
        <svg
          viewBox="0 0 384 512"
          width="26"
          height="32"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M343.75868 106.66243V79.430205L363.52365 63.999997H149.63354L20.476345 176.2736h85.656075c-.15534 2.12494-.21914 4.04644-.21914 6.22563 0 20.84472 7.2192 38.08662 21.67203 51.86089 14.45284 13.79702 32.25124 20.64784 53.32651 20.64784 4.92319 0 9.75059-.36794 14.43842-1.02419-2.90722 6.50082-4.37457 12.52302-4.37457 18.14228 0 9.87526 4.49924 20.4304 13.46715 31.6418-39.23377 2.6705-68.06112 9.73264-86.43702 21.16322-10.53108 6.49907-19.000207 14.70396-25.390349 24.5311-6.390569 9.89933-9.577754 20.51525-9.577754 31.9616 0 9.64822 2.062375 18.33611 6.21907 26.06233 4.156694 7.7263 9.577757 14.07047 16.312223 18.98408 6.71825 4.96781 14.46899 9.10088 23.219 12.46874 8.73429 3.34378 17.40643 5.71858 26.06106 7.06258 8.62707 1.34222 17.20471 1.9985 25.70579 1.9985 13.46887 0 26.95353-1.73428 40.54711-5.18707 13.56165-3.48461 26.28022-8.64143 38.17105-15.4927 11.85935-6.80488 21.51545-16.0865 28.9219-27.7183 7.39024-11.67998 11.09457-24.80499 11.09457-39.33613 0-11.01584-2.24964-21.03852-6.7502-30.14073-4.46864-9.07202-9.93785-16.54102-16.45271-22.34403-6.5008-5.81263-12.99987-11.15539-19.51512-15.9679-6.50083-4.84488-12.00021-9.75058-16.46884-14.8129-4.4848-5.04657-6.73444-10.05419-6.73444-14.98395 0-4.92145 1.73422-9.67183 5.21588-14.26559 3.45451-4.6095 7.67376-9.04795 12.60967-13.30571 4.93756-4.24944 9.87523-8.96788 14.79665-14.13302 4.92147-5.14719 9.14072-11.82739 12.60971-20.00822 3.48467-8.17907 5.20318-17.44489 5.20318-27.75679 0-13.4527-2.54714-24.46065-7.54735-33.31348-.59369-1.02243-1.21757-1.80338-1.87511-3.02225l56.90745-46.672136v17.118526c-7.39373.92969-6.62422 5.34582-6.62422 10.6352v128.66719c0 5.95832 4.8751 10.83382 10.83386 10.83382h3.98869c5.95835 0 10.83386-4.87506 10.83386-10.83382V117.29282c0-5.27669.77741-9.68801-6.56167-10.63039zM236.39865 329.14114c1.14099.7503 3.7039 2.78075 7.7184 6.03838 4.0495 3.24319 6.797 5.69582 8.26567 7.41432 1.43851 1.66381 3.5792 4.16501 6.37617 7.54734 2.81268 3.3744 4.7184 6.30394 5.71853 8.73425 1.00016 2.4767 2.01603 5.46089 3.04636 8.94556.98567 3.44488 1.48486 6.97595 1.48486 10.56169 0 17.04813-6.56338 29.68007-19.65604 37.85915-13.125 8.18083-28.76651 12.27368-46.93767 12.27368-9.18709 0-18.2031-1.09289-27.06247-3.1951-8.84322-2.11665-17.31192-5.3362-25.39035-9.60185-8.07846-4.25771-14.57754-10.20337-19.50072-17.79659-4.93764-7.64012-7.40645-16.41464-7.40645-26.24962 0-10.32022 2.79692-19.28987 8.42233-26.90588 5.59343-7.62564 12.93774-13.3919 22.03208-17.3154 9.0624-3.94582 18.24946-6.74232 27.56166-8.39827 9.31221-1.7023 18.79679-2.555 28.43842-2.555 4.46862 0 7.93582.25115 10.40465.69607.45456.21918 3.03188 2.07025 7.73456 5.56326 4.70401 3.46237 7.62565 5.59519 8.75047 6.38401zm-3.35823-100.5779c-7.40648 8.85938-17.73454 13.2882-30.95363 13.2882-11.85933 0-22.29766-4.76482-31.26554-14.31195-8.99984-9.52309-15.42235-20.32803-19.34408-32.43061-3.93752-12.10871-5.90585-23.98423-5.90585-35.648 0-13.6942 3.59542-25.35184 10.7809-34.97598 7.18727-9.64952 17.49915-14.48477 30.93786-14.48477 11.87507 0 22.37423 5.03825 31.43704 15.15677 9.09434 10.08482 15.60961 21.41303 19.5169 33.96799 3.92176 12.5392 5.87345 24.52979 5.87345 35.98399 0 13.44658-3.70256 24.60984-11.07663 33.45436z" />
        </svg>
      );
    case "orcid":
      return (
        <svg
          viewBox="0 0 24 24"
          width="30"
          height="30"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zM7.369 4.378c.525 0 .947.431.947.947 0 .525-.422.947-.947.947-.525 0-.946-.422-.946-.947 0-.525.421-.947.946-.947zm-.722 3.038h1.444v10.041H6.647V7.416zm3.562 0h3.9c3.712 0 5.344 2.653 5.344 5.025 0 2.578-2.016 5.025-5.325 5.025h-3.919V7.416zm1.444 1.303v7.444h2.297c3.272 0 4.022-2.484 4.022-3.722 0-2.016-1.284-3.722-4.097-3.722h-2.222z" />
        </svg>
      );
    case "x":
      return (
        <svg
          viewBox="0 0 24 24"
          width="28"
          height="28"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      );
    case "researchmap":
      return (
        <svg
          viewBox="0 0 24 24"
          width="30"
          height="30"
          aria-hidden="true"
        >
          <defs>
            <mask id="researchmap-rm-mask">
              <rect width="24" height="24" fill="white" />
              <text
                x="10.5"
                y="16.5"
                textAnchor="middle"
                fontFamily="Inter, system-ui, sans-serif"
                fontSize="14"
                fontWeight="800"
                letterSpacing="-0.3"
                fill="black"
              >
                rm
              </text>
            </mask>
          </defs>
          <path
            d="M1.5 1.5 Q1.5 0.5 2.8 1 L23 11.4 Q24.2 12 23 12.6 L2.8 23 Q1.5 23.5 1.5 22.5 Z"
            fill="currentColor"
            mask="url(#researchmap-rm-mask)"
          />
        </svg>
      );
    default:
      return null;
  }
}
